import { render, staticRenderFns } from "./rewardRedBag.vue?vue&type=template&id=7df3e089&scoped=true"
import script from "./rewardRedBag.vue?vue&type=script&lang=js"
export * from "./rewardRedBag.vue?vue&type=script&lang=js"
import style0 from "./rewardRedBag.vue?vue&type=style&index=0&id=7df3e089&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7df3e089",
  null
  
)

export default component.exports